import React, { useEffect, useState } from 'react'
import { country, handleValidateCodevalue, indianStates } from '../Utility/constant'
import { StyledLeadContainer, StyledSubHeader } from './Styled'
import { MenuItem, TextField } from '@mui/material'
import { useSelector } from 'react-redux'
import TextFiledWithLabel from './TextFieldWithLabel'

const AddressFields = ({ setEntityDetails,entityDetails,onChange , disabled = false}) => {
    
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [isIndia, setIsIndia] = useState(false);
           useEffect(()=>{
                   if(entityDetails?.country == "India"){
                       setIsIndia(true)
                   }
                   else{
                    setEntityDetails ({
                        ...entityDetails,
                        state : "Other"
                    })
                       setIsIndia(false)
                   }
               },[entityDetails?.country])
  return (<>
  <StyledSubHeader>
                   {handleValidateCodevalue(internationalise,'COMMON_ADDRESS')}
                  </StyledSubHeader>
                  
                    <StyledLeadContainer  sx={{
                    width: "72% !important",
                }}>
                 <TextField
                        fullWidth
                        sx = {{width: "100% !important"}}
                        disabled = {disabled}
                        id="address" 
                        name="address"
                         variant='standard'
                        value={entityDetails?.address || ""}
                        onChange={onChange}
                        label = {handleValidateCodevalue(internationalise,'COMMON_REG_ADD')}
                        // InputLabelProps={{
                        //     shrink: true,
                        // }}
                    />
                    </StyledLeadContainer>
                    <StyledLeadContainer>
        
                                     <TextField 
                        disabled = {disabled}
                        id="city" 
                        name="city"
                        value={entityDetails?.city || ""}
                         variant='standard'
                                   
                        onChange={onChange}
                        label = {handleValidateCodevalue(internationalise,'COMMON_CITY')}
                        // InputLabelProps={{
                        //     shrink: true,
                        // }}
                    />
                                    <TextField
                                        select
                                       disabled = {(isIndia ? false : true ) || disabled}
                                        name= "state"
                                        value= { isIndia ? entityDetails?.state : "Other"}
                                        label = {handleValidateCodevalue(internationalise,'COMMON_STATE')}
                                        onChange={onChange}
                                         variant='standard'
                                   
                        //                 InputLabelProps={{
                        //                 shrink: true,
                        // }} 
                                    >
                                        {indianStates.map((item) => 
                                            <MenuItem
                                            key ={item.name} value ={item.name} >
                                                {item.name}
                                            </MenuItem>
                                            )}
                                    </TextField>
                <TextField
                                    select
                                    
                                    disabled = {disabled}
                                    variant='standard'
                                    name = "country"
                                    value={entityDetails?.country || ''}
                                    label = {handleValidateCodevalue(internationalise,'COMMON_COUNTRY')}
                                    onChange={onChange} 
                                    InputLabelProps={{
                                    shrink: true,
                        }}
                                    >
                                        {country.map((item)=>( 
                                          <MenuItem  key={item.name} value = {item.name}>
                                            {item.name}
                                            </MenuItem>
                                       ))}
                                    </TextField>
                                    <TextFiledWithLabel
                                    sx = {{visibility : 'hidden'}}
                                    />
                    </StyledLeadContainer>
                    </>
  )
}

export default AddressFields